import {ReactElement} from "react";
import {useTranslation} from "react-i18next";
import {isWZReturn} from "../helpers";
import {WZDetails} from "./types";

type DocumentInfoProps = {
    wz: WZDetails;
};

export function DocumentInfo({wz}: DocumentInfoProps): ReactElement {
    const {t} = useTranslation();
    const documentType = isWZReturn(wz.isReturn)
        ? t('user-page.wzs.types.return')
        : t('user-page.wzs.types.sale');
    const listNumber = wz.listNumber?.trim() || t('user-page.wz.no-value');

    return (
        <div className="types">
            <div className="type">
                <span>{t('user-page.wz.contractor')}</span>
                <span>{wz.contractor.name}</span>
            </div>
            <div className="type">
                <span>{t('user-page.wz.receiver')}</span>
                <span>{wz.receiver.name}</span>
            </div>
            <div className="type">
                <span>{t('user-page.wz.document-type')}</span>
                <span>{documentType}</span>
            </div>
            <div className="type">
                <span>{t('user-page.wz.forwarder')}</span>
                <span>{wz.forwarder}</span>
            </div>
            <div className="type">
                <span>{t('user-page.wz.note-number')}</span>
                <span>{listNumber}</span>
            </div>
        </div>
    );
}
